import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import IntelligenceIndex from "@/pages/IntelligenceIndex";
import HowItWorks from "@/pages/HowItWorks";
import LouiseApp from "@/louise/LouiseApp";
import { IS_LOUISE_HOST } from "@/louise/lib";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {IS_LOUISE_HOST ? (
          <Route path="/*" element={<LouiseApp />} />
        ) : (
          <>
            <Route path="/" element={<Landing />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/legacy-intelligence-index" element={<IntelligenceIndex />} />
            <Route path="/louise/*" element={<LouiseApp />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
